import { Box, Card, Stack, Tooltip, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { Products } from "../../../../../../merchant/admin/priceList/priceListTypes"
import { Tag } from "../../../../../../../shared/components/createOrder/components/shop/product/Tag"
import { OfferTag } from "../../../../../../../shared/components/createOrder/components/shop/product/OfferTag"
import { OnlyXLeftTag } from "../../../../../../../shared/components/createOrder/components/shop/product/OnlyXLeftTag"
import { faBurgerGlass } from "@fortawesome/pro-solid-svg-icons"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInfoCircle } from "@fortawesome/pro-light-svg-icons"
import { CardImage } from "../../CardImage"
import { ProductOfferAmount } from "./ProductOfferAmount"
import { useState } from "react"
import { ProductDetailsDialog } from "../../../../../../../shared/components/createOrder/components/shop/product/ProductDetailsDialog"

const useStyles = makeStyles()((theme) => ({
    card: {
        position: "relative",
        boxShadow: "none",
        cursor: "pointer",
    },
    tagTopLeftWrapper: {
        position: "absolute",
        top: 0,
        left: 0,
    },
    cardContent: {
        padding: ".375rem 0 0 0",
    },
    cardContentEmpty: {
        padding: ".5rem",
        fontWeight: 500,
        color: "#00000060",
    },
    title: {
        fontSize: "1.125rem",
        fontWeight: 600,
        lineHeight: 1.3,
        color: theme.palette.tailwind.slate[800],
    },
    placeholder: {
        height: "7rem",
        color: "#94A3B8",
        display: "flex",
        borderRadius: ".25rem",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme.palette.tailwind.slate[200],
    },
    infoIcon: {
        cursor: "pointer",
        paddingTop: ".2rem",
    },
}))

type ProductOfferProps = {
    product: Products
}

export const ProductOffer = ({ product }: ProductOfferProps) => {
    const { classes } = useStyles()
    const [productId, setProductId] = useState<number | null>(null)

    const showOfferTag = product.offerDetails
    const onCardClick = () => setProductId(product.id)

    const productLeftInStock = product?.orderDetails?.productLeftInStock

    return (
        <>
            <Card onClick={onCardClick} className={classes.card}>
                <CardImage imageUri={product?.imageUrl} icon={faBurgerGlass} />

                {product?.productDescription?.marketingTag && (
                    <Box className={classes.tagTopLeftWrapper}>
                        <Tag>{product?.productDescription?.marketingTag}</Tag>
                    </Box>
                )}
                {showOfferTag && <OfferTag top="5.5rem" right="0.75rem" offerDetails={product.offerDetails} />}
                <OnlyXLeftTag top="0rem" right="0rem" amount={productLeftInStock} />
                <Box className={classes.cardContent}>
                    <Stack direction="row" alignItems="center" gap="0.5rem">
                        <Typography className={classes.title} pt=".2rem">
                            {product.name}
                        </Typography>
                        <Tooltip title={product?.description} arrow>
                            <FontAwesomeIcon className={classes.infoIcon} icon={faInfoCircle} />
                        </Tooltip>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                        <ProductOfferAmount product={product} />
                    </Stack>
                </Box>
            </Card>
            {productId && <ProductDetailsDialog productId={productId} handleClose={() => setProductId(null)} />}
        </>
    )
}

export const ProductOfferEmpty = () => {
    const { classes } = useStyles()

    return (
        <Card className={classes.card}>
            <Box className={classes.placeholder}>
                <FontAwesomeIcon size="2x" icon={faBurgerGlass} />
            </Box>

            <Box className={classes.cardContentEmpty}>
                <LocalizedStrict id="user-home-empty-offers-text">
                    <Typography variant="subtitle2">You have no offers right now</Typography>
                </LocalizedStrict>
            </Box>
        </Card>
    )
}
